var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-navigation-drawer',{attrs:{"app":"","clipped":"","fixed":"","mobile-breakpoint":"lg","width":"300px","value":_vm.isOpen,"color":"grey lighten-4"}},[_c(_vm.currentSidebar,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }